import {
  ArrowRightIcon,
  ArrowLineUpRightIcon,
  HideFor,
  Link,
} from "/App.Components";
import "./BlockTop.scss";
import { BlockTopProps } from "/Models/Generated/BlockTopProps";
import { createSpreadableBem } from "/Helpers/createBem";

interface Props extends BlockTopProps {
  externalArrowIcon?: boolean;
  theme?: "primary" | "secondary";
}

const BlockTop = (props: Props) => {
  const {
    heading,
    headingPropertyName,
    link,
    linkPropertyName,
    externalArrowIcon,
    theme = "primary",
  } = props;

  const bem = createSpreadableBem("block-top-norad");

  return (
    <div {...bem("")}>
      <div
        {...bem("__heading", {
          "--primary": theme === "primary",
          "--secondary": theme === "secondary",
        })}
      >
        {(!!heading || !!headingPropertyName) && (
          <h2
            {...bem("", {
              "epi-editContainer": !!headingPropertyName,
            })}
            data-epi-property-name={headingPropertyName}
          >
            {heading}
          </h2>
        )}
      </div>
      <div
        className={linkPropertyName ? "epi-editContainer" : ""}
        data-epi-property-name={linkPropertyName}
        data-epi-property-render={linkPropertyName ? "client" : null}
      >
        {link && (
          <>
            <HideFor mobile tablet>
              <Link
                {...link}
                icon={externalArrowIcon ? ArrowLineUpRightIcon : ArrowRightIcon}
                iconPlacement="after"
                size="small"
              />
            </HideFor>
            <HideFor desktop desktopMedium desktopLargeUp>
              <Link
                {...link}
                icon={externalArrowIcon ? ArrowLineUpRightIcon : ArrowRightIcon}
                iconPlacement="after"
                size="x-small"
              />
            </HideFor>
          </>
        )}
      </div>
    </div>
  );
};

export default BlockTop;
